export class Classify {
    public id: number;
    public name: string;
    public description: string;
    public office: string;
    public phone: string;
    public mail: string;
    public created: Date;
}